export function getPreferredAppOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  const configuredOrigin = process.env.REACT_APP_PUBLIC_URL?.trim();
  if (configuredOrigin) {
    return configuredOrigin.replace(/\/+$/, "");
  }
  return "";
}

export function buildAuthRedirectUrl(path = "/auth/callback") {
  return new URL(path, `${getPreferredAppOrigin()}/`).toString();
}

export function readSupabaseTokensFromUrl() {
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  const params = new URLSearchParams(hash);
  const accessToken = params.get("access_token");
  const refreshToken = params.get("refresh_token");
  const errorDescription = params.get("error_description") || params.get("error");

  return {
    accessToken,
    refreshToken,
    errorDescription,
    hasTokens: Boolean(accessToken && refreshToken),
  };
}

export function clearAuthCallbackUrl() {
  window.history.replaceState(null, "", window.location.pathname);
}
